export default __webpack_public_path__ + "static/media/video-call.0e4e774d.svg";